import {action, observable} from 'mobx';
import Container, {Service} from 'typedi';
import {
  CreateUserDTO,
  DeleteUserDTO,
  GetUserListDTO,
  HttpService,
  ResponseDTO,
  GetUserByIdDTO,
  UpdateUserDTO,
  GetInfoAccountDTO,
  GetUserShareDTO,
} from '@/shared';
import {
  IResponseGetUserById,
  IResponseGetUserList,
  IResponseShareUser,
} from '@/types';

@Service()
export class UserService {
  @observable
  private httpService = Container.get(HttpService);

  @action.bound
  public async getUserList(
    getUserListDTO: GetUserListDTO,
  ): Promise<ResponseDTO<IResponseGetUserList>> {
    return this.httpService.request(getUserListDTO);
  }
  public async createUser(createUserDTO: CreateUserDTO): Promise<ResponseDTO> {
    return this.httpService.request(createUserDTO);
  }
  public async updateUser(updateUserDTO: UpdateUserDTO): Promise<ResponseDTO> {
    return this.httpService.request(updateUserDTO);
  }
  public async deleteUser(deleteUserDTO: DeleteUserDTO): Promise<ResponseDTO> {
    return this.httpService.request(deleteUserDTO);
  }
  public async getUserById(
    getUserByIdDTO: GetUserByIdDTO,
  ): Promise<ResponseDTO<IResponseGetUserById>> {
    return this.httpService.request(getUserByIdDTO);
  }
  public async getInfoAccount(
    getInfoAccountDTO: GetInfoAccountDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(getInfoAccountDTO);
  }
  public async getUserShare(
    getUserShareDTO: GetUserShareDTO,
  ): Promise<ResponseDTO<IResponseShareUser[]>> {
    return this.httpService.request(getUserShareDTO);
  }
}
